import { hash } from 'immutable';
import { combineActions, handleActions } from 'redux-actions';

import { resourceUpserters } from '../core';
import { coreActions } from '../core-actions';
import * as actions from './profileActions';
import {
  makeProfileFull,
  mkProfileStore,
  type ProfilePropsImmu,
  type ProfileStore,
  type ProfileStoreProps,
} from './profileTypes';

export const reducer = handleActions<
  ProfileStore,
  | coreActions.SanitizeAction
  | ReturnType<typeof actions.getProfile>
  | ReturnType<typeof actions.getProfileSuccess>
  // | ReturnType<typeof actions.getProfileFailure>
  | ReturnType<typeof actions.updateProfile>
  | ReturnType<typeof actions.updateProfileSuccess>

  // | ReturnType<typeof actions.verifyEmail>
  // | ReturnType<typeof actions.verifyEmailSuccess>
  // | ReturnType<typeof actions.verifyEmailFailure>

  // | ReturnType<typeof actions.verifyIdentity>
  | ReturnType<typeof actions.verifyIdentitySuccess>
  // | ReturnType<typeof actions.verifyIdentityFailure>

  // | ReturnType<typeof actions.getVerificationStatus>
  | ReturnType<typeof actions.getVerificationStatusSuccess>
  // | ReturnType<typeof actions.getVerificationStatusFailure>
>(
  {
    [coreActions.SANITIZE]: (state) =>
      state.set(
        'resourcesById',
        state.resourcesById.map((resource) =>
          resource.mergeDeep(
            makeProfileFull({
              username: hash(resource.username).toString(),
              firstName: hash(resource.firstName).toString(),
              lastName: hash(resource.lastName).toString(),
              companyName: hash(resource.companyName).toString(),
              ...(resource.primaryAddress && {
                primaryAddress: {
                  fullName: hash(resource.primaryAddress.fullName).toString(),
                  line1: hash(resource.primaryAddress.line1).toString(),
                  line2: hash(resource.primaryAddress.line2).toString(),
                  city: hash(resource.primaryAddress.city).toString(),
                  state: hash(resource.primaryAddress.state).toString(),
                  country: hash(resource.primaryAddress.country).toString(),
                  zipCode: hash(resource.primaryAddress.zipCode).toString(),
                },
              }),
              ...(resource.primaryPhone && {
                primaryPhone: {
                  number: hash(resource.primaryPhone.number).toString(),
                },
              }),
              ...(resource.primaryEmail && {
                primaryEmail: {
                  address: hash(resource.primaryEmail.address).toString(),
                },
              }),
            }),
          ),
        ),
      ),

    [actions.getProfile.type]: (state) => state.merge({ isLoading: true }),

    [actions.getProfileSuccess.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResources<ProfilePropsImmu, ProfileStoreProps>(state, data),

    [actions.updateProfile.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResources<ProfilePropsImmu, ProfileStoreProps>(state, {
        resources: [makeProfileFull(data)],
      }),

    [actions.updateProfileSuccess.type]: (state, { payload: data }) =>
      resourceUpserters.upsertResources<ProfilePropsImmu, ProfileStoreProps>(state, data),

    [actions.verifyIdentitySuccess.type]: (state, { payload: data }) =>
      state.merge({
        verificationAttempts: data.callCount,
        verificationThreshold: data.verificationThreshold,
        status: data.status,
        message: data.message,
        ...(data.status === 'PASSED' ? { verified: true } : {}),
      }),

    [actions.getVerificationStatusSuccess.type]: (state, { payload: data }) =>
      state.merge({
        verified: Boolean(data.success),
        status: data.status,
        verificationAttempts: data.callCount,
        verificationThreshold: data.verificationThreshold,
      }),

    [combineActions(
      actions.getProfileFailure,
      actions.verifyEmailFailure,
      actions.verifyPhoneFailure,
      actions.verifyIdentityFailure,
      actions.getVerificationStatusFailure,
    ).toString()]: (state: any, { payload: error }: any) => resourceUpserters.completeWithError(state, error),
  },
  mkProfileStore(),
);

export default reducer;
